module.exports = __webpack_public_path__ + "static/img/bg8.639c0733.png";